/* global globalThis */
import { APP_CONST } from "../Constants/app.constant";
import {
  sessionStorageGetItem,
  sessionStorageSetItem,
  sessionStorageRemoveItem,
} from "./Storage/storageUtils";

export const isChunkLoadError = (error) => {
  const chunkFailedMessage = /Loading chunk \d+ failed/;
  const chunkLoadError = error?.name === "ChunkLoadError";
  const chunkFailedInMessage = chunkFailedMessage.test(error?.message);
  return chunkLoadError || chunkFailedInMessage;
};

export const handleChunkError = (error) => {
  if (isChunkLoadError(error)) {
    sessionStorageSetItem(APP_CONST.CHUNK_RELOAD_KEY + "_active", "true");

    const reloadCount = Number.parseInt(
      sessionStorageGetItem(APP_CONST.CHUNK_RELOAD_KEY) || "0",
      10,
    );

    if (reloadCount < APP_CONST.MAX_CHUNK_RELOAD_ATTEMPTS) {
      const newCount = reloadCount + 1;
      sessionStorageSetItem(APP_CONST.CHUNK_RELOAD_KEY, String(newCount));
      console.warn(
        `Chunk load error detected. Reloading page (attempt ${newCount}/${APP_CONST.MAX_CHUNK_RELOAD_ATTEMPTS})...`,
      );
      globalThis.location.reload();
    } else {
      console.error(
        `Maximum chunk reload attempts (${APP_CONST.MAX_CHUNK_RELOAD_ATTEMPTS}) reached. Stopping reloads.`,
      );
      sessionStorageRemoveItem(APP_CONST.CHUNK_RELOAD_KEY);
      sessionStorageRemoveItem(APP_CONST.CHUNK_RELOAD_KEY + "_active");
    }
  }
};

export const initChunkErrorHandler = () => {
  const wasActiveReload = sessionStorageGetItem(
    APP_CONST.CHUNK_RELOAD_KEY + "_active",
  );

  if (wasActiveReload) {
    sessionStorageRemoveItem(APP_CONST.CHUNK_RELOAD_KEY + "_active");

    setTimeout(() => {
      if (!sessionStorageGetItem(APP_CONST.CHUNK_RELOAD_KEY + "_active")) {
        const count = sessionStorageGetItem(APP_CONST.CHUNK_RELOAD_KEY);
        if (count) {
          sessionStorageRemoveItem(APP_CONST.CHUNK_RELOAD_KEY);
        }
      }
    }, 3000);
  }
};
